import {CssBaseline, useMediaQuery} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {createTheme, Direction, ThemeProvider} from '@mui/material/styles';
import RTL from './RTL';
import {Outlet} from 'react-router-dom';
import socket from '../../socket';
import Sidebar from './Sidebar';
import {Box} from '@mui/system';
import Header from './Header';
import {useState} from 'react';

export default function App() {
	socket.connect();
	const {t} = useTranslation();
	const theme = createTheme({
		direction: t('_dir') as Direction,
		components: {
			MuiSkeleton: {
				defaultProps: {
					animation: 'wave'
				}
			},
			MuiTextField: {
				defaultProps: {
					size: 'small'
				}
			},
			MuiSelect: {
				defaultProps: {
					size: 'small'
				}
			}
		},
		typography: {
			fontFamily: 'peyda'
		}
	});
	const matches = useMediaQuery(theme.breakpoints.up('sm'));
	const [open, setOpen] = useState(matches && localStorage.getItem('drawer_state') !== 'close');
	
	const drawerWidth = !matches || open ? 240 : 56;
 
	const handleDrawerToggle = () => {
		localStorage.setItem('drawer_state', open ? 'close' : 'open');
		setOpen(!open);
	};
 
	return (
		<ThemeProvider theme={theme}>
			<RTL direction={theme.direction}>
				<CssBaseline/>
				<div className="flex flex-col h-full">
					<Header handleDrawerToggle={handleDrawerToggle}/>
					<Box className="flex flex-row grow">
						<Sidebar open={open} matches={matches} handleDrawerToggle={handleDrawerToggle} drawerWidth={drawerWidth}/>
						<Box className="grow">
							<Outlet/>
						</Box>
					</Box>
				</div>
			</RTL>
		</ThemeProvider>
	);
}
